function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: "2",
  stroke: "#000",
  d: "M20 4.236L4.057 15.82l6.09 18.742h19.707l6.09-18.742L20 4.236z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: "2",
  fill: "none",
  strokeDasharray: "4",
  stroke: "#000",
  d: "M10 35l18-25"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "11",
  cy: "34",
  r: "2.5"
}), /*#__PURE__*/React.createElement("circle", {
  cy: "10.002",
  cx: "27.594",
  r: "2.5"
}));